module.exports = __webpack_public_path__ + "img/person2.63b65edc.png";